module.exports = __webpack_public_path__ + "static/media/certificate_template_p2.03370815.PNG";